import IBAN from "iban";

export const checkIban = (
  ibanStr: string,
  prevIbanLength: number,
  setFormData: (x: any) => void,
  formData: any
) => {
  const ibanEl: HTMLInputElement | null = document.querySelector(
    "input[type=text]#bankAccountNumber"
  );

  if (prevIbanLength < ibanStr.length) {
    if (ibanStr.length === 4) {
      setFormData({
        ...formData,
        bankAccountNumber: `${ibanStr} `,
      });
    } else if (ibanStr.length === 9) {
      setFormData({
        ...formData,
        bankAccountNumber: `${ibanStr} `,
      });
    } else if (ibanStr.length === 14) {
      setFormData({
        ...formData,
        bankAccountNumber: `${ibanStr} `,
      });
    }
  }

  if (IBAN.isValid(ibanStr.replace(" ", ""))) {
    //ibanEl?.blur();
    ibanEl?.focus();
    ibanEl?.setCustomValidity("");
    console.log("ok");
    return;
  } else {
    if (ibanStr.length >= 19) {
      console.log("not ok");
      ibanEl?.setCustomValidity("Ongeldig bankrekening nummer");
      ibanEl?.reportValidity();
      return;
    }
  }
};
